export default __webpack_public_path__ + "img/246fe2e7eb27fb0daeab9cda5c72d237.png";